import { Psh } from '@/mocks/psh';
import { PARTNER_ROW } from '@/constants';
import { Top5V21Partner } from '@/services/top5-v2-1/http-response-types';
import { _time } from './helper';

export function partnerGotoLink(
    partnerCategoryId: number,
    position: number,
    clickOutType: number,
    partnerSetHash: Psh,
    pageViewId: string,
    canRunAds: boolean
): string {
    const ps = {
        id: partnerCategoryId,
        ts: _time(),
        pos: position || 1,
        cot: clickOutType,
        rsrc: partnerSetHash['ranking_source'],
        psh: partnerSetHash['psh'],
        pvid: pageViewId,
        adb: localStorage.app_ad_block ? 1 : null,
        pcnt: partnerSetHash['count'],
    };

    // append template name
    if (window.__template__) {
        ps['template'] = window.__template__;
    }

    if (partnerSetHash) {
        if (partnerSetHash['host_id']) {
            ps['host_id'] = partnerSetHash['host_id'];
        }

        if (partnerSetHash['sea_lp_category']) {
            ps['sea_lp_category'] = partnerSetHash['sea_lp_category'];
        }

        if (partnerSetHash['sea_lp_category_id']) {
            ps['sea_lp_category_id'] = partnerSetHash['sea_lp_category_id'];
        }

        if (partnerSetHash['sea_lp_traffic_source']) {
            ps['sea_lp_traffic_source'] =
                partnerSetHash['sea_lp_traffic_source'];
        }

        if (partnerSetHash['sea_lp_traffic_source_id']) {
            ps['sea_lp_traffic_source_id'] =
                partnerSetHash['sea_lp_traffic_source_id'];
        }

        if (partnerSetHash['ranking_category']) {
            ps['ranking_category'] = partnerSetHash['ranking_category'];
        }

        if (partnerSetHash['ranking_category_id']) {
            ps['ranking_category_id'] = partnerSetHash['ranking_category_id'];
        }

        if (partnerSetHash['ranking_traffic_source']) {
            ps['ranking_traffic_source'] =
                partnerSetHash['ranking_traffic_source'];
        }

        if (partnerSetHash['ranking_traffic_source_id']) {
            ps['ranking_traffic_source_id'] =
                partnerSetHash['ranking_traffic_source_id'];
        }
    }

    if (canRunAds === undefined) {
        ps['adb'] = 1;
    } else {
        ps['adb'] = null;
    }

    const sP = new URLSearchParams();
    Object.keys(ps).forEach(function (pN) {
        sP.append(pN, ps[pN]);
    });

    let s = btoa(sP.toString());
    s = s.replace('+', '-');
    s = s.replace('/', '_');

    let params = '';

    try {
        params = '?page_referer_url=' + location.host + location.pathname;
    } catch (e) {
        console.log('page_referer_url param failed');
    }

    return `/goto/${s}${params}`;
}

export function appendGotoLink(
    partner: Top5V21Partner,
    index: number,
    canRunAds: boolean,
    partnerSetHash: Psh,
    pageViewId: string
): Top5V21Partner {
    partner.api_clickout = partnerGotoLink(
        partner.cp_id,
        index + 1,
        PARTNER_ROW,
        partnerSetHash,
        pageViewId,
        canRunAds
    );
    return partner;
}
